/**
 * Ar App
 * This is a simple API for AR App
 *
 * OpenAPI spec version: 1.0.0
 * Contact: csong@lsq.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { FieldOption } from './fieldOption';

export interface StringFieldOption extends FieldOption { 
    /**
     * Regex string for validation
     */
    pattern?: string;
    /**
     * mask for the stringField
     */
    mask?: string;
    /**
     * Max Length of the string input.
     */
    maxLength?: number;
    /**
     * Min Length of the string input
     */
    minLength?: number;
    /**
     * Sets the input type
     */
    inputType?: StringFieldOption.InputTypeEnum;
}
export namespace StringFieldOption {
    export type InputTypeEnum = 'Email' | 'Tel' | 'Password' | 'VerificationCode';
    export const InputTypeEnum = {
        Email: 'Email' as InputTypeEnum,
        Tel: 'Tel' as InputTypeEnum,
        Password: 'Password' as InputTypeEnum,
        VerificationCode: 'VerificationCode' as InputTypeEnum
    };
}